import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import { Provider } from 'react-redux';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router';
import { Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import App from './components/App';
import Register from './views/authentication/register';
import Maintanance from './views/authentication/maintanance';
import Confirmation from './views/authentication/confirmation';
import Recoverpwd from './views/authentication/recover-pwd';
import createRootReducer from './reducers/index';
// import { FETCH_COMPANIES_SUCCESS } from './actions/companyActions';
import {  GET_USER_DATA } from './actions/authActions';
import './assets/scss/style.css';


//clear logs in prod build - temp solution
function noop() {}

if (process.env.NODE_ENV !== 'development') {
	console.log = noop;
	//console.warn = noop;
	//console.error = noop;
}

const localStorageMiddleware = ({ getState }) => {
	return next => action => {
		const result = next(action);
		// console.log('RESULTS_', result, getState());
		// if (result.type === "GET_USER_DATA") {
		// 	const state  = getState();
		// 	const userData = {
		// 		currentUser: state.currentUser,
		// 		company: state.companiesReducer.companies.length > 1 ? {id: 0} : state.companiesReducer.companies[0]
		// 	};
		// 	localStorage.setItem('userData', JSON.stringify(userData))
		// }
		return result;
	};
};

const reHydrateStore = () => {
	const data = localStorage.getItem('userData');
	// if (data) {
	// 	return {
	// 		userData: JSON.parse(data)
	// 	}
	// }
	return undefined;
};

const history = createBrowserHistory();
const store = createStore(
  	createRootReducer(history), // root reducer with router state
	reHydrateStore(),
  	compose(
		applyMiddleware(
		  	routerMiddleware(history), // for dispatching history actions
		  	thunk,
			localStorageMiddleware
		),
  	),
);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
    	<Switch>
			<Route component={App} exact={true} path='/' />
			<Route component={App} strict={true} path='/dashboard' />
			<Route component={App} exact={true} path='/login' />
			<Route path='/recover' exact={true} render={() => ( <Recoverpwd /> )} />
			<Route path='/confirmation' exact={true} render={() => ( <Confirmation /> )} />
			<Route path='/register' exact={true} render={() => ( <Register /> )} />
			<Route path='*' exact={true} render={() => ( <Maintanance /> )} />
      	</Switch>
    </ConnectedRouter>
  </Provider>
  ,document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js